export const PRICE_DIFF_PERCENTAGE_THRESHOLD = 0.01 // 1%
